import { render } from "./edit.vue?vue&type=template&id=2672d5ae"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=2672d5ae&lang=css"
script.render = render

export default script